import { PureComponent } from "react"

/* Components */
import { Picture } from "../components"

/* Chip (same as ump-front) */
import { Chip } from "@cuba-go/poker-ui"

/* Constants */
import { env, sound, tempstake, utils } from "../constants"

/* UUID */
import { v4 as uuidv4 } from "uuid"


/*
    Chips — the chip selector + bet controls (clear / cancel / double / repeat).
    Generic over the current stake keys, so it works for the blackjack bet set
    (main, perfectPair, twentyone, crazySeven, bustBonus).
*/
class Chips extends PureComponent {

    /* Cap for a given bet key (main = max, side bets = fraction of max) */
    cap = (key, max) => utils.betMax(key, max)

    setChip = index => {
        this.props.setSelected(index)
        sound.play("selectchip", 0.2)
    }

    clear = () => {
        this.props.setStake({ ...tempstake })
        this.props.setList([])
        sound.play("cancel", 0.2)
    }

    notify = type => {
        const { notify } = this.props
        notify(type, "show")
        const timer = setTimeout(() => { notify(type, "close"); clearTimeout(timer) }, 2000)
    }

    cancel = () => {

        const { stake, setStake, list, setList } = this.props
        const index = list.findLastIndex(e => e.type === "add")
        if (index === -1) return

        const _list = [...list]
        const _stake = { ...stake }
        const last = list[index]

        if (last.isDouble) {
            _list.forEach((item, i) => {
                if (item.uuid === last.uuid) {
                    if (_stake[item.target]) _stake[item.target] = _stake[item.target] - item.value
                    _list[i].type = "remove"
                }
            })
        }
        else {
            _stake[last.target] = (_stake[last.target] || 0) - last.value
            _list[index].type = "remove"
        }

        setStake(_stake)
        setList(_list)
        sound.play("cancel", 0.2)
    }

    double = () => {

        const { stake, setStake, list, setList, balance, max } = this.props
        const _stake = { ...stake }
        const _list = [...list]
        const uuid = uuidv4()

        let doubleTotal = 0
        let maxError = false

        Object.keys(_stake).forEach(key => {
            const current = parseFloat(_stake[key]) || 0
            if (current > 0) {
                if (current * 2 <= this.cap(key, max)) {
                    doubleTotal += current
                    _stake[key] = current * 2
                    _list.push({ value: current, type: "add", target: key, uuid, isDouble: true })
                }
                else {
                    maxError = true
                }
            }
        })

        if (maxError) this.notify("maxBetError")

        if (doubleTotal > parseFloat(balance)) {
            this.notify("balanceError")
            return
        }

        setStake(_stake)
        setList(_list)
        sound.play("sound", 0.2)
    }

    refresh = () => {

        const { last, setStake, setList, balance } = this.props

        if (utils.getTotal(last) > 0 && utils.getTotal(this.props.stake) === 0) {

            if (utils.getTotal(last) > parseFloat(balance)) {
                this.notify("balanceError")
                return
            }

            setStake(last)
            setList(utils.reconnectionChipsList(last, true))
            sound.play("repeat", 0.2)
        }
    }

    isActive = type => {
        const { stake, last, list } = this.props
        if (type === "clear" || type === "double") return utils.getTotal(stake) > 0
        if (type === "cancel") return list.findIndex(e => e.type === "add") !== -1
        if (type === "refresh") return utils.getTotal(last) > 0 && utils.getTotal(stake) === 0
        return false
    }

    render = () => {

        const { selected, chips } = this.props
        const active = { opacity: 1 }
        const inactive = { opacity: 0.5, cursor: "default" }

        return (
            <div className="chips-container">

                <div onClick={() => this.clear()} className="chips-button" style={this.isActive("clear") ? active : inactive}>
                    <Picture src={`${env.mediapoint}/images/bet/delete.png`} alt="Delete" />
                    Очистить
                </div>

                <div onClick={() => this.cancel()} className="chips-button" style={this.isActive("cancel") ? active : inactive}>
                    <Picture src={`${env.mediapoint}/images/bet/cancel.png`} alt="Cancel" />
                    Отменить
                </div>

                <div className="chips">
                    {chips.map((chip, index) =>
                        <div onClick={() => this.setChip(index)} key={`${index}`} className={selected === index ? "chip active-chip" : "chip"}>
                            <Chip value={chip.value} size={58} chips={chips.map(c => c.value)} />
                        </div>
                    )}
                </div>

                <div onClick={() => this.double()} className="chips-button" style={this.isActive("double") ? active : inactive}>
                    <span>2x</span>
                    Удвоить
                </div>

                <div onClick={() => this.refresh()} className="chips-button" style={this.isActive("refresh") ? active : inactive}>
                    <Picture src={`${env.mediapoint}/images/bet/refresh.png`} alt="Refresh" />
                    Повторить
                </div>

            </div>
        )
    }
}

export default Chips
